// deps
import styled from "styled-components";

// Exact values not represented in DLS spacing tokens
const TOP_PADDING = "10px";

export const Container = styled.div.attrs((props: { isEmpty: boolean; isLoading: boolean }) => props)`
    position: sticky;
    top: 0;
    z-index: 4;
    background: ${props => props.theme.colors[props.theme.colorMode].background_Primary};
    border-radius: 0 0 ${props => (props.isLoading ? 0 : props.theme.cornerRadius.large)}
        ${props => (props.isLoading ? 0 : props.theme.cornerRadius.large)};
    padding: ${TOP_PADDING} ${props => props.theme.spacing.medium} ${props => props.theme.spacing.medium}
        ${props => props.theme.spacing.medium};
    margin-bottom: ${props => (props.isLoading ? 0 : props.theme.spacing.xxLarge)};
    span {
        color: ${props =>
            props.isEmpty
                ? `${props.theme.colors[props.theme.colorMode].text_disabled}`
                : `${props.theme.colors[props.theme.colorMode].primary}`};
        pointer-events: ${props => (props.isEmpty ? "none" : "auto")};
    }
    input {
        border-radius: ${props => props.theme.cornerRadius.medium};
        text-transform: uppercase;
        border: 1px solid ${props => props.theme.colors[props.theme.colorMode].border_Subtle_Secondary};
    }
`;
